<template>
	<base-layout>
		<template slot="page-header-right">
			<auth-app-header></auth-app-header>
		</template>

		<template slot="page-content">
			<div class="col-xs-2 admin-layout-item" id="admin-menu">
				<app-menu></app-menu>
			</div>
			<div class="col-xs-10 admin-layout-item">
				<div class="admin-page-container">
					<div class="row admin-page-header-container">
						<slot name="admin-page-header">
							--admin-page-header--
						</slot>
					</div>

					<div class="row  admin-page-content-container">
						<slot name="admin-page-content">
							--admin-page-content--
						</slot>
					</div>
				</div>
			</div>
		</template>
	</base-layout>
</template>

<script>
import Menu from "@/components/common/Menu";
import AuthenticatedAppHeader from "@/components/common/AuthenticatedAppHeader";
import AppHeaderTitle from "@/components/common/AppHeaderTitle";

const namespaceService = require("@/utils/namespace-api");
import router from "@/router";

export default {
  components: {
    "app-menu": Menu,
    "auth-app-header": AuthenticatedAppHeader
  }
};
</script>


<style scoped>
#page-content {
  display: flex;
  width: 100%;
  flex: 1;
}
.admin-layout-item {
  padding: 0;
}
.admin-page-header-container {
  display: flex;
  align-items: center;
	margin-bottom: 20px;
	flex-wrap: wrap;
}
.admin-page-container {
  padding: 20px 0 20px 3.5%;
}
#admin-menu {
  padding-top: 20px;
  border-right-width: 1px;
  border-right-style: dashed;
  border-color: #a4abbd;
  height: 100%;
}
.admin-layout-item,
.admin-page-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AdminBaseLayout.vue